import { useEffect, useState } from 'react'

export const useKeyDown = (key: string): boolean => {
  const [keyDown, setKeyDown] = useState<boolean>(false)

  useEffect(() => {
    const downHandler = (event: KeyboardEvent) => setKeyDown(event.key === key)
    const upHandler = () => setKeyDown(false)

    window.addEventListener('keydown', downHandler)
    window.addEventListener('keyup', upHandler)

    return () => {
      window.removeEventListener('keydown', downHandler)
      window.removeEventListener('keyup', upHandler)
    }
  }, [key])

  return keyDown
}
